import { useCallback, useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import { OnProgressProps } from 'react-player/base'

const url = 'https://www.youtube.com/live/x57GYTMVxqI?si=C_zXh7ZptemKHQnC'

export const useMediaPlayback = ({ url }) => {
  const videoId = get_youtube_id(url)
  const playerRef = useRef<ReactPlayer | null>(null)
  const [isPlaying, setIsPlaying] = useState<boolean>(false)
  const [progress, setProgress] = useState<any>(0)

  const thumbnail = `http://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
  const [duration, setDuration] = useState<number>()

  const onPlay = useCallback(() => {
    if (!isPlaying) {
      setIsPlaying(true)
    } else {
      setIsPlaying(false)
    }
  }, [isPlaying])

  const onTimestamps = useCallback(
    (progress: OnProgressProps) => {
      let duration = (progress.playedSeconds / 33) * 100
      //   if (!isNaN(duration)) setProgress(Math.round(duration))
    },
    [progress],
  )

  return {
    videoId,
    thumbnail,
    playerRef,
    isPlaying,
    onPlay,
    setDuration,
    progress,
    onTimestamps,
  }
}

const get_youtube_id = (url) => {
  let regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm
  return regex.exec(url)[3]
}
